import React, {memo} from 'react'
import {
  withErrorHandling,
  withHelmet,
  withPropsPresent,
  withVersionData,
  withNavigation,
  withEnvironmentData,
  withServiceData
} from '../../../../hoc'
import {goBack} from '../../../../util'
import {archiveEnvironment} from '../../../../backend'
import {Button, Confirm} from 'semantic-ui-react'
import {cache} from 'swr'


const _ArchiveEnvironment = (
  {
    service,
    version,
    environment,
    history,
    navigate,
    archiveEnvironment,
    basePath = '/c/services/:serviceId/versions/:versionId/environments',
    query
  }
) => {
  const getPathPrefix = () => {
    return basePath
      .replace(':serviceId', service.id)
      .replace(':versionId', version.id)
  }

  const onArchiveConfirmed = async (environment) => {
    await archiveEnvironment(environment.id)
    cache.clear()
    goBack(history, navigate, {
      defaultTo: getPathPrefix(),
      returnPath: query.returnPath
    })
  }

  const onArchiveCancelled = () => {
    goBack(history, navigate, {
      defaultTo: getPathPrefix(),
      returnPath: query.returnPath
    })
  }

  return (
    <Confirm
      open
      header={`Archive environment: ${environment.name} in version: ${version.name} in service: ${service.name}`}
      content={`The archive will removed after 1 year. Are you sure you want to proceed?`}
      cancelButton='Cancel'
      confirmButton={() => <Button primary content='Proceed'
                                   onClick={async () => await onArchiveConfirmed(environment)}/>}
      onCancel={onArchiveCancelled}
    />
  )
}

let ArchiveEnvironment = (props) => {
  const {handleError} = props
  props = {
    ...props,
    history: window.history,
    archiveEnvironment: handleError(archiveEnvironment)
  }
  return (<_ArchiveEnvironment {...props}/>)
}

ArchiveEnvironment = withPropsPresent(ArchiveEnvironment, ['environment', 'version', 'service'])
ArchiveEnvironment = withHelmet(ArchiveEnvironment, 'Archive Service')
ArchiveEnvironment = withServiceData(ArchiveEnvironment, 'Loading service...')
ArchiveEnvironment = withVersionData(ArchiveEnvironment, 'Loading version...')
ArchiveEnvironment = withEnvironmentData(ArchiveEnvironment, 'Loading environment...')
ArchiveEnvironment = withNavigation(ArchiveEnvironment)
ArchiveEnvironment = withErrorHandling(ArchiveEnvironment)
ArchiveEnvironment = memo(ArchiveEnvironment)

export {_ArchiveEnvironment, ArchiveEnvironment}

export default ArchiveEnvironment